import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import GridLayoutContainer from 'redux/containers/pages/dashboard/GridLayoutContainer'
import { setHomepageArticles, setHomePageStoriesIsLoaded } from 'redux/actions'

const Dashboard = ({ homepageArticles, aol }) => {
  const containerRef = useRef('container')
  const contentRef = useRef('content')
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHomepageArticles(homepageArticles))
    dispatch(setHomePageStoriesIsLoaded(!!homepageArticles))
  }, [homepageArticles, dispatch])

  return (
    <div ref={containerRef}>
      <div ref={contentRef}>
        <GridLayoutContainer aol={aol} />
      </div>
    </div>
  )
}

export default Dashboard
